import { isMockAdobeAnlitycs } from '@/utils';

let isMockCreated = false;

export const sendAdobeEvent = (eventData) => {
  if (!window.appEventData) {
    // create if not exists
    window.appEventData = [];
  }

  // mock push event
  if (isMockAdobeAnlitycs && !isMockCreated) {
    console.log('AdobeAnalitycs Mock is active');
    // overrites push to show events in the console
    const originalPush = Array.prototype.push;
    window.appEventData.push = function (...args) {
      return originalPush.apply(this, args);
    };
    isMockCreated = true;
  }

  console.log('[AdobeAnalitycs] event sent: ', eventData); // TODOO: after stage tested, print only if dev o local
  window.appEventData.push(eventData);
};
